<template>
  <div style="background-color: #f1f3f6;">
    <div>
      <div id="warehouse-sc-tab-header">
        <div class="flexbox header">
          <div class="warehouse-sc-title-icon ">
            <img :src="iconUrl" alt="" class="img-responsive">
          </div>
          <h2 class="warehouse-sc-title mr-r-10">STOCKCREW倉庫</h2>
          <nav-tabs
            @handleShowBackdrop="handleShowBackdrop"
            @handleCloseBackdrop="handleCloseBackdrop"
            :tab="tab">
          </nav-tabs>
        </div>
      </div>
      <div class="modal-backdrop" id="modal-backdrop" v-show="isShowBackdrop"></div>
    </div>
    <div id="warehouse-sc-tab-content" style="padding: 0 40px;">
      <breadcrumb :tab="tab" :subTab="subTab"></breadcrumb>
      <tab-content :tab="tab" :subTab="subTab"></tab-content>
    </div>
  </div>
</template>

<script>
import NavTabs from './NavTabs'
import Breadcrumb from './components/Breadcrumb'
import TabContent from './TabContent'
import SettingService from '@/services/settingservice'
import tabs from '@/common/warehouse-sc-tabs'

export default {
  components: {
    NavTabs,
    Breadcrumb,
    TabContent
  },
  data () {
    return {
      tab: null,
      subTab: null,
      loader: null,
      isShowBackdrop: false
    }
  },
  computed: {
    allowTabs () {
      return tabs.map(tab => tab.id)
    },
    allowSubTabs () {
      return tabs.flatMap(tab => tab.childs.map(child => child.id))
    },
    iconUrl () {
      return this.$store.getters.getWareHouseIcons['salmonSc']
    }
  },
  created () {
    this.tab = this.$route.params.tab
    this.subTab = this.$route.params.subTab
    if ((this.tab && !this.allowTabs.includes(this.tab)) || (this.subTab && !this.allowSubTabs.includes(this.subTab))) {
      this.$router.push('/not-found')
    }
    this.getSellerInfo()
  },
  mounted () {
    this.$events.listen('handleError', (err, modalWidth = 400) => {
      this.$store.commit('toggleModal', {
        show: true,
        message: err,
        modalWidth: modalWidth
      })
    })
  },
  methods: {
    async getSellerInfo () {
      await SettingService.getSellerInformation()
        .then(response => {
          this.$store.commit('setUser', response.seller)
          if (this.$store.getters.getUser.scWarehouseUse === '0') {
            this.$router.push('/not-found')
            return false
          }
          if (this.$store.getters.getUser.scWarehouseUse === '9' && ['top', 'inventory', 'delivery'].includes(this.tab)) {
            this.$router.push('/not-found')
            return false
          }
        })
    },
    handleShowBackdrop () {
      this.isShowBackdrop = true
      $('.header').attr('style', 'background-color: #fff')
    },
    handleCloseBackdrop () {
      this.isShowBackdrop = false
      $('.header').attr('style', 'background-color: #f1f3f6')
    }
  },
  watch: {
    $route (to) {
      if (this.$store.getters.getUser.scWarehouseUse === '0') {
        this.$router.push('/not-found')
        return false
      }

      const toTab = to.params.tab
      const subTab = to.params.subTab
      if (this.$store.getters.getUser.scWarehouseUse === '9' && !['expense-details', 'settings', 'shipping'].includes(toTab)) {
        this.$router.push('/not-found')
        return false
      }

      if ((toTab && !this.allowTabs.includes(toTab)) || (subTab && !this.allowSubTabs.includes(subTab))) {
        this.$router.push('/not-found')
      } else {
        this.tab = toTab
        this.subTab = subTab
      }
    }
  },
  beforeDestroy () {
    this.$events.remove('done')
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
#warehouse-sc-tab-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
#warehouse-sc-tab-header .warehouse-sc-title-icon {
  width: 40px;
  margin-right: 20px;
}
.modal-backdrop {
  z-index: 2;
  opacity: 0.4;
}
#warehouse-sc-tab-header > .header {
  padding: 20px 40px;
  flex-wrap: wrap;
  z-index: 3;
  background-color: #f1f3f6;
  width: 100%;
}
</style>
<style>
.modal-open {
  overflow: unset;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/Warehouses.vue